export default defineNuxtRouteMiddleware(async (to, from) => {
    const personStore = usePersonStore();
    const authStore = useAuthStore();

    // Check if the route exists, otherwise redirect to not-found
    const router = useRouter();
    const resolved = router.resolve(to.fullPath);
    // If no matched route and not already on /not-found, redirect
    if (!resolved.matched.length && to.path !== '/not-found') {
        return navigateTo('/not-found');
    }

    // Initialize auth if not already done (but skip during OAuth callback)
    if (!authStore.loggedIn && !to.path.startsWith('/auth/callback')) {
        await authStore.initializeAuth();
    }

    const isAuthenticated = authStore.loggedIn;

    // Define public routes that don't require authentication
    const publicRoutes = [
        '/auth/login',
        '/auth/callback',
        '/auth/logout',
    ];
    
    // Check if current route is public
    const isPublicRoute = publicRoutes.some(route => to.path.startsWith(route));
    
    // Check if page explicitly marks itself as public
    const isPagePublic = to.meta.public === true;
    
        // If not a public route and user is not authenticated, redirect to login
    if (!isPublicRoute && !isPagePublic && !isAuthenticated) {
        // Use auth store login method which stores redirect in cookie
        return navigateTo('/auth/login');
    }
    
    // If user is authenticated but profile is not ready, redirect 
    // to auth app for profile completion
    if (isAuthenticated && !isPublicRoute && authStore.user && !authStore.user.identity.profile_ready) {
        // Redirect to auth app instead of going through full login process
        const config = useRuntimeConfig();
        await navigateTo(config.public.pb.authApp, { external: true });
        return;
    }

    // Handle root path redirect
    if (to.path === '/') {
        if (isAuthenticated) {
            return navigateTo('/dashboard');
        } else {
            // Show public landing page or redirect to login
            return navigateTo('/auth/login');
        }
    }

    // Handle impersonation restrictions
    if (personStore.impersonating && !['/dashboard', '/vault', '/details', '/settings'].includes(to.path)) {
        return navigateTo('/dashboard');
    }
});
